import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateProfileCitizenshipRequest } from './updateProfileCitizenship.types';

export async function updateProfileCitizenship(
  data: UpdateProfileCitizenshipRequest
): Promise<void> {
  await axiosInstance.put('/client-profiles/export-control', data);
}
